import { render, staticRenderFns } from "./Vocab.vue?vue&type=template&id=7f6453e4"
import script from "./Vocab.vue?vue&type=script&lang=js"
export * from "./Vocab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports